// extracted by mini-css-extract-plugin
module.exports =  {"alert":"vABWup8bIxpld1j4Myd4","code":"ZqhbCQXR0e_3RgljdggU"};